import React, { useState, useCallback } from 'react';
import { Container } from 'components/UI';
import { Title } from '@landing/ui';
import Item from './Item';

import * as styles from './Services.module.scss';

export default function Services({ title, subtitle, items }) {
  const [activeSection, setActiveSection] = useState(null);

  const handleClick = useCallback(
    id => {
      if (activeSection === id) {
        setActiveSection(null);
      } else {
        setActiveSection(id);
      }
    },
    [activeSection],
  );

  return (
    <Container className={styles.container} background="gray" theme="stairs">
      <div className={styles.layout}>
        <Title>{title}</Title>
        <div className={styles.contentWrapper}>
          <div className={styles.column}>
            <p className={styles.subtitle}>{subtitle}</p>
          </div>
          <div className={styles.column}>
            {items.map(({ title, description, list }, i) => (
              <Item
                key={title}
                id={i}
                title={title}
                description={description}
                list={list}
                isOpened={activeSection === title || (i === 0 && activeSection === null)}
                onClick={() => handleClick(title)}
              />
            ))}
          </div>
        </div>
      </div>
    </Container>
  );
}
